'use client'

import { storyblokEditable } from '@storyblok/react/rsc'
import { clsx } from 'clsx'
import { type FC, type PropsWithChildren } from 'react'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokContainerLinkType } from '../../storyblok'
import { useStoryblokWebOrAppLink } from '../../useStoryblokLink'

export const StoryblokContainerLinkContent: FC<
  PropsWithChildren<StoryblokComponentProps<StoryblokContainerLinkType>>
> = ({ blok, children }) => {
  const { appHref, display, href } = blok
  const linkProps = useStoryblokWebOrAppLink({
    appLink: appHref,
    link: href,
  })

  if (!linkProps) {
    return null
  }

  return (
    <a
      {...storyblokEditable(blok)}
      {...linkProps}
      className={clsx(display === 'block' && 'block')}
    >
      {children}
    </a>
  )
}
